import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f51cecc0&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f51cecc0')) {
      api.createRecord('f51cecc0', component.options)
    } else {
      api.reload('f51cecc0', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f51cecc0&", function () {
      api.rerender('f51cecc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SWvEOW8Z3cw0/JS/comp/cancellationPolicy.vue"
export default component.exports